import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNumericField as e, getFieldDefaultValue as i } from "./fieldUtils.js";

function t(e) {
  return "date" === e.type || "esriFieldTypeDate" === e.type;
}

function s(e) {
  return "oid" === e.type || "esriFieldTypeOID" === e.type;
}

function l(e) {
  return "global-id" === e.type || "esriFieldTypeGlobalID" === e.type;
}

var d = /*#__PURE__*/function () {
  function d(i) {
    _classCallCheck(this, d);

    if (this.fields = i, this._fieldsMap = new Map(), this._dateFieldsSet = new Set(), this._numericFieldsSet = new Set(), this.dateFields = [], this.numericFields = [], this._requiredFields = null, !i) return;
    var _d = [];

    var _iterator = _createForOfIteratorHelper(i),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;

        var _i = n && n.name;

        if (_i) {
          var u = r(_i);
          this._fieldsMap.set(_i, n), this._fieldsMap.set(u, n), _d.push(u), t(n) ? (this.dateFields.push(n), this._dateFieldsSet.add(n)) : e(n) && (this._numericFieldsSet.add(n), this.numericFields.push(n)), s(n) || l(n) || (n.editable = null == n.editable || !!n.editable, n.nullable = null == n.nullable || !!n.nullable);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    _d.sort(), this.uid = _d.join(",");
  }

  _createClass(d, [{
    key: "destroy",
    value: function destroy() {
      this._fieldsMap.clear();
    }
  }, {
    key: "requiredFields",
    get: function get() {
      if (!this._requiredFields) {
        this._requiredFields = [];

        var _iterator2 = _createForOfIteratorHelper(this.fields),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e = _step2.value;
            s(_e) || l(_e) || _e.nullable || void 0 !== i(_e) || this._requiredFields.push(_e);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return this._requiredFields;
    }
  }, {
    key: "has",
    value: function has(e) {
      return null != this.get(e);
    }
  }, {
    key: "get",
    value: function get(e) {
      return null != e ? this._fieldsMap.get(e) || this._fieldsMap.get(r(e)) : void 0;
    }
  }, {
    key: "isDateField",
    value: function isDateField(e) {
      return this._dateFieldsSet.has(this.get(e));
    }
  }, {
    key: "isNumericField",
    value: function isNumericField(e) {
      return this._numericFieldsSet.has(this.get(e));
    }
  }, {
    key: "normalizeFieldName",
    value: function normalizeFieldName(e) {
      var i = this.get(e);
      if (i) return i.name;
    }
  }]);

  return d;
}();

function r(e) {
  return e.toLowerCase().trim();
}

export { d as default };